import { get } from "svelte/store";
export class FormValidator {
    constructor(answersService, form, instance, answers) {
        this.answersService = answersService;
        this.form = form;
        this.instance = instance;
        this.answers = answers;
    }
    async validate() {
        const sectionsValidation = await Promise.all(this.form.sections.map(section => this.validateSection(section)));
        return sectionsValidation.every(isValid => isValid);
    }
    async validateSection(section) {
        const sectionInstance = this.instance.sections.get(section.id);
        if (!sectionInstance) {
            throw new Error('No se ha encontrado una instancia de sección necesaria.');
        }
        const isRequired = get(sectionInstance.required);
        //Si la sección no es requerida debemos seleccionar automaticamente
        //todas las opciones N/A en las preguntas que contenga
        if (!isRequired) {
            for (const question of section.questions) {
                await this.selectNA(question);
            }
            return true;
        }
        const questionsValidation = await Promise.all(section.questions.map(question => this.validateQuestion(question)));
        return questionsValidation.every(isValid => isValid);
    }
    async validateQuestion(question) {
        var _a;
        const answer = this.answers.get(question.id);
        //Si la pregunta es requerida es necesario
        //que su valor de respuesta no esté vacio
        if (question.forced && !(answer === null || answer === void 0 ? void 0 : answer.value)) {
            return false;
        }
        //Si la pregunta tiene opciones de respuesta podría ser
        //que estuviera desbloqueando una sección anidada.
        //Si es así debemos validar también las secciones que esté desbloqueando.
        const unlockSubsections = (_a = question.options.questionOptions) === null || _a === void 0 ? void 0 : _a.some(option => {
            return answer && option.id == answer.value && option.unLock;
        });
        if (!unlockSubsections) {
            return true;
        }
        //Hay que validar las subsecciones de la pregunta
        const subsectionsValidations = await Promise.all(question.sections.map(section => this.validateSection(section)));
        return subsectionsValidations.every(isValid => isValid);
    }
    async selectNA(question) {
        const { questionOptions } = question.options;
        if (questionOptions) {
            const naOption = questionOptions.find(({ isNA }) => isNA);
            if (naOption) {
                const answer = this.answers.get(question.id);
                if (answer.value !== naOption.id) {
                    answer.value = naOption.id;
                    await this.answersService.saveAnswer(answer);
                }
            }
        }
        for (const section of question.sections) {
            for (const question of section.questions) {
                await this.selectNA(question);
            }
        }
    }
}
